import React, { FC } from 'react';
import { RouteComponentProps } from '@reach/router';

import { CheckoutSessionProvider } from 'hooks/context/checkoutSession';
import { MerchantPaymentConfigContextProvider } from 'hooks/context/merchantPaymentConfig';
import { CalcProvider } from 'hooks/context/calc';
import { GiftCardContextProvider } from 'hooks/context/giftcards';
import { ModalProvider } from 'hooks/context/modals';

const Checkout: FC<RouteComponentProps<{checkoutSessionId: Uuid}>> = ({ checkoutSessionId, children }) => (
  <CheckoutSessionProvider checkoutSessionId={checkoutSessionId}>
    <MerchantPaymentConfigContextProvider>
      <GiftCardContextProvider>
        <CalcProvider checkoutSessionId={checkoutSessionId}>
          <ModalProvider>
            {children}
          </ModalProvider>
        </CalcProvider>
      </GiftCardContextProvider>
    </MerchantPaymentConfigContextProvider>
  </CheckoutSessionProvider>
);

export { Checkout };
